import { getAuth } from "firebase/auth";

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public details?: unknown,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  let token: string | undefined;
  try {
    token = await getAuth().currentUser?.getIdToken();
  } catch {
    // Local development works with the server-side auth bypass.
  }
  const headers = new Headers(init?.headers);
  if (init?.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const response = await fetch(`/api${path}`, { ...init, headers });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new ApiError(body?.error || "Request failed.", response.status, body);
  }
  return body as T;
}
